import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectUser } from "../login/loginSlice";

import config from "../../config";
const { contents } = config.endpoints;

export const Contents = () => {
  const user = useSelector(selectUser)
  
  window.location.href = contents.strapi+"?auth="+user.access_token;
  
  return null;
};
